import { isSisterStore } from "./sisterStore";

export const ADMIN_EMAILS_PT = ["testee@gmail.com", "geovanaantunes177@gmail.com"];
export const ADMIN_EMAILS_EN = [
  "testengv@gmail.com",
  "testesv@gmail.com",
  "testru@gmail.com",
];

export function adminEmails() {
  return isSisterStore() ? ADMIN_EMAILS_EN : ADMIN_EMAILS_PT;
}

export function isAdminEmail(email) {
  return Boolean(email) && adminEmails().includes(email);
}

/** Admin por allowlist de email ou role no banco (public.users.role). */
export function isAdminUser(user) {
  if (!user) return false;
  return user.role === "admin" || isAdminEmail(user.email);
}

/** Lab interno: leilão na home (stories/banners). Personalizar promo = só isAdminUser(). */
export const FEATURE_TESTER_EMAILS = [
  "testee@gmail.com",
  "robertasiqueirabarros@gmail.com", // Roberta — lab leilão até go-live WPP
];

export function isFeatureTester(email) {
  return FEATURE_TESTER_EMAILS.includes(String(email || "").trim().toLowerCase());
}
